import selectComponentAccounts from './selectComponentAccounts';
export default (primaryAccountId, getIds = false) => {
	const componentAccounts = selectComponentAccounts();
	const mappedComponentAccounts = componentAccounts?.filter((m) =>
		m.relatedComponentAccounts?.some((s) => s.primaryAccountId === primaryAccountId)
	);
	if (getIds) {
		const ids = [];
		mappedComponentAccounts.forEach((item) => ids.push(item.accountId));
		return ids;
	}
	return mappedComponentAccounts;
};
